import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_LOADING = 'SET_LOADING';
export const IS_FLOW_RUN = 'IS_FLOW_RUN';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_LOADING](state, value) {
		Vue.set(state, 'loading', value);
	},
	[IS_FLOW_RUN](state, value) {
		Vue.set(state, 'isFlowRun', value);
	},
};

export default mutations;
